import { Controller } from "@hotwired/stimulus"

// This controller manages filters that use a single text input expecting a number.
export default class extends Controller {
  static get targets() {
    return ["input"]
  }

  static get values() {
    return { name: String, number: Number }
  }

  connect() {
    this.inputTarget.value = this._formatNumberValue(this.numberValue)
  }

  // Format the input value and preserve the cursor position. For this to work the input has to be a text input.
  format() {
    const cursorPosition = this.inputTarget.selectionStart
    const atEndOfInput = cursorPosition === this.inputTarget.value.length
    const previousValue = this.numberValue

    this.numberValue = this.inputTarget.value.replace(/\D/g, "")

    if (this._formatNumberValue(this.numberValue) === this.inputTarget.value) {
      // The input is already formatted
      return
    }

    const previousNumberOfCommas = (this.inputTarget.value.match(/,/g) || []).length
    this.inputTarget.value = this._formatNumberValue(this.numberValue)

    if (atEndOfInput) {
      // We were at the end of the input, no need to adjust the cursor position
      return
    }

    const currentNumberOfCommas = (this.inputTarget.value.match(/,/g) || []).length

    // The default new cursor position is the last cursor position
    let newCursorPosition = cursorPosition

    if (currentNumberOfCommas > previousNumberOfCommas) {
      // When a comma got added we need to increment the cursor position
      newCursorPosition = cursorPosition + 1
    } else if (currentNumberOfCommas < previousNumberOfCommas) {
      // When a comma got removed we need to decrement the cursor position
      newCursorPosition = [cursorPosition - 1, 0].sort()[1]
    } else if (previousValue === this.numberValue) {
      // When the value didn't change we assume invalid input, and decrement the cursor position
      newCursorPosition = cursorPosition - 1
    }

    this.inputTarget.setSelectionRange(newCursorPosition, newCursorPosition)
  }

  apply() {
    this.dispatchFilterEvent()
  }

  clear() {
    this.inputTarget.value = ""
    this.numberValue = 0
    this.dispatchFilterEvent()
  }

  dispatchFilterEvent() {
    let values = []

    if (this.numberValue !== 0) {
      values = [this.numberValue]
    }

    this.dispatch("filter", { detail: { name: this.nameValue, values: values } })
  }

  _formatNumberValue(numberValue) {
    if (numberValue === 0) {
      return ""
    }

    return Intl.NumberFormat(i18n.locale).format(numberValue)
  }
}
